/**
 * Created by lihanying on 2017/7/6.
 */

export const GETCLUBSTANDBYLIST = 'GETCLUBSTANDBYLIST'
export const GETPERIOD = 'GETPERIOD'



// WEBPACK FOOTER //
// ./src/containers/ClubStandby/constants.js